import { ENTITY_TYPES } from '../../editor/EditorTypes';

interface EntityPaletteProps {
  selectedEntity?: string;
  onSelectEntity: (entityType: string) => void;
}

export function EntityPalette({ selectedEntity, onSelectEntity }: EntityPaletteProps) {
  return (
    <div className="entity-palette">
      <h3>Entities</h3>
      <div className="palette-items">
        {ENTITY_TYPES.map(type => {
          const imageSrc = `/assets/${type.toLowerCase()}.png`;
          return (
            <button
              key={type}
              className={`palette-item ${selectedEntity === type ? 'selected' : ''}`}
              onClick={() => onSelectEntity(type)}
              title={type}
            >
              <span className="entity-icon">
                <img 
                  src={imageSrc} 
                  alt={type}
                  style={{ 
                    width: '48px', 
                    height: '48px', 
                    imageRendering: 'pixelated',
                    display: 'block'
                  }} 
                />
              </span>
              <span className="entity-label">{type}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
